import { Component, Input, OnInit } from '@angular/core';
import { ContentStorageService } from '@ptl/global-components';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';

@Component({
    selector: 'app-content-storage',
    templateUrl: './content-storage.component.html',
    styleUrls: ['./content-storage.component.scss'],
    standalone: false
})
export class ContentStorageComponent implements OnInit {

  isAuthoring: boolean = false;
  @Input() hideInspectorView: string = 'hide';
  @Input() contentGroup: string;
  @Input() content: string;
  displayContent: any;

  constructor(
    private contentStorage: ContentStorageService,
    private authoringMode: AuthoringModeService
  ) { }

  ngOnInit(): void {
    this.storeContent();
    this.isAuthoring = this.hideInspectorView === 'hide' ? false : this.authoringMode.getAuthoringMode();

  }

  storeContent() {
    if (this.content && this.contentGroup) {
      try {
        const jsonContent = JSON.parse(this.content);
        const parsedContent: Map<any, any> = new Map(jsonContent.map(obj => [obj.contentKey, obj.contentValue]));
        this.displayContent = parsedContent;
        this.contentStorage.storeContentMapFromComponent(this.contentGroup, parsedContent);
      } catch (err) {
        console.log('JSON Content Parse and Map Error:', err);
      }
    }
  }

  hideInspector() {
    this.isAuthoring = false;
  }
}
